import { AbstractControl, ValidationErrors } from "@angular/forms";

export function specialCharacterValidator(control: AbstractControl): ValidationErrors | null {

  if(control && (control.value !== null || control.value !== undefined)){
    const validate = /[^A-Za-z0-9]/.test(control.value);

    if (!validate){
      return {
        'specialCharacterValidator' : true
      };
    }
  }

  return null;
}
